import React from "react";

import { UserEntityForm, UserFormProps } from "Bands/components";
import { fields } from "./formData";

export const UserVehicleForm: React.FC<UserFormProps> = ({ ...rest }) => {
  return (
    <UserEntityForm
      {...rest}
      fields={fields}
      style={{
        gridTemplateColumns: "1fr 1fr 1fr",
      }}
    />
  );
};
